import React, { useContext, useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { isExpired } from 'react-jwt'
import { AuthContext } from '../Context/AuthContext/AuthContext'
import { AppRoutes } from '../../Router/Routes'
import DashboarRouter from './DashboardRouter/DashboarRouter'
import { ConfigContext } from '../Context/ConfigContext/ConfigContext'

import { getAccesos } from '../API/Users/UserRequests'
import { ConfirmDialog } from 'primereact/confirmdialog'

export const AppRouter = () => {



  const ppfToken = localStorage.getItem(process.env.REACT_APP_StorageToken);
  const expired = isExpired(ppfToken);


  const { userAuth, signIn } = useContext(AuthContext);
  const { config, setConfig } = useContext(ConfigContext);


  useEffect(() => {
    const root = document.documentElement;
    if (config.theme === 'Dark') {
      root.classList.add('Dark');
      root.classList.remove('Light');
    } else {
      root.classList.add('Light');
      root.classList.remove('Dark');
    }
  }, [config, userAuth])

  const infoUser = async (u) => {
    let idUser = u.idUser
    let user = u
    const resultAccesos = await getAccesos(idUser)
    if (resultAccesos) {

      user = { ...u, Accesos: resultAccesos?.accesos }

    }

    signIn(user)
  }

  const expiredUser = () => {
    if (!expired) {
      if (!userAuth?.isLogged) {
        const user = localStorage.getItem(process.env.REACT_APP_StorageUser);
        try {
          const u = JSON.parse(user);
          infoUser(u)
          // signIn(u);

          if (u?.WebConfig) {
            setConfig(JSON.parse(u?.WebConfig));
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  useEffect(() => {
    expiredUser()
  }, [])





  if (expired) {
    return (
      <div className={config.theme}>
        <BrowserRouter>
          <Routes>
            {AppRoutes.rutasOut.map((r) => {
              return <Route path={`${process.env.REACT_APP_ENV}/${r?.path}`} element={r?.element} />
            })}

            <Route path="*" element={<Navigate from="*" to={`${process.env.REACT_APP_ENV}/login`} />} />
          </Routes>
        </BrowserRouter>
      </div>
    )
  }
  else {
    return (
      <div className={config.theme} style={{ overflow: 'hidden' }}>
        <BrowserRouter>
          <Routes>

            {AppRoutes.rutasIn.map((r, i) => {
              return <Route key={i} path={`${process.env.REACT_APP_ENV}/${r?.path}`} element={r?.element} />
            })}

            <Route path="*" element={<DashboarRouter />} />
          </Routes>
        </BrowserRouter>
      </div>
    )

  }
}
